import { render, staticRenderFns } from "./DetailedKPA.vue?vue&type=template&id=3af51adf"
import script from "./DetailedKPA.vue?vue&type=script&lang=js"
export * from "./DetailedKPA.vue?vue&type=script&lang=js"
import style0 from "./DetailedKPA.vue?vue&type=style&index=0&id=3af51adf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports